// ======================================================================
// File Name       : course
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import * as ActionTypes from '../../constants/actionTypes/course';

export function receiveCourseList(recordNum, courseList) {
  return {
    type: ActionTypes.COURSE_RECEIVE_COURSE_LIST,
    recordNum,
    courseList,
  };
}

export function receiveCourseRelation(recordNum, courseRelationList) {
  return {
    type: ActionTypes.COURSE_RECEIVE_COURSE_RELATION,
    recordNum,
    courseRelationList,
  };
}

export function initDataForDetailEditConfirmDialog(courseSecernId, childItemSercernIdList) {
  return {
    type: ActionTypes.COURSE_INIT_DATA_FOR_DETAIL_EDIT_CONFIRM_DIALOG,
    courseSecernId,
    childItemSercernIdList: childItemSercernIdList || [],
  };
}

export function initDataForCourseRegisterDialog(courseSecernId) {
  return {
    type: ActionTypes.COURSE_INIT_DATA_FOR_REGISTER_DIALOG,
  };
}

export function handleInputChange(payload) {
  return {
    type: ActionTypes.COURSE_INPUT_CHANGE,
    payload,
  };
}

export function doReceiveSearchCondition(payload) {
  return {
    type: ActionTypes.COURSE_RECEIVE_SEARCH_CONDITION,
    payload,
  };
}

export function addUserRelation() {
  return {
    type: ActionTypes.COURSE_ADD_USER_RELATION,
  };
}

export function doReceiveUserList(userList) {
  return {
    type: ActionTypes.COURSE_RECEIVE_USER_LIST,
    userList,
  };
}

export function doReceiveUserSearchResult(startPosition, recordNum, userList) {
  return {
    type: ActionTypes.COURSE_RECEIVE_USER_SEARCH_RESUTL,
    startPosition,
    recordNum,
    userList,
  };
}

export function removeUserRelation(userSecernId) {
  return {
    type: ActionTypes.COURSE_REMOVE_USER_RELATION,
    userSecernId,
  };
}

export function removeAllUserRelation(isAdminHasCourseRelation) {
  return {
    type: ActionTypes.COURSE_REMOVE_ALL_USER_RELATION,
    isAdminHasCourseRelation,
  };
}

export function addRemoveUser(userSecernId) {
  return {
    type: ActionTypes.COURSE_ADD_REMOVE_USER,
    userSecernId,
  };
}

export function addRemoveAllUser() {
  return {
    type: ActionTypes.COURSE_ADD_REMOVE_ALL_USER,
  };
}

export function editPeriodTime(userSecernId, payload) {
  return {
    type: ActionTypes.COURSE_EDIT_PERIOD_TIME,
    userSecernId,
    payload,
  };
}

export function changeEditType(editType) {
  return {
    type: ActionTypes.COURSE_CHANGE_EDIT_TYPE,
    editType,
  };
}

export function resetData() {
  return {
    type: ActionTypes.COURSE_RESET_INIT_DATA,
  };
}

export function receiveResetCourseCondition() {
  return {
    type: ActionTypes.COURSE_RESET_COURSE_CONDITION,
  };
}

export function changeData() {
  return {
    type: ActionTypes.COURSE_CHANGE_DATA,
  };
}

export function getThumbnailDefault(data) {
  return {
    type: ActionTypes.COURSE_GET_THUMBNAIL_DEFAULT,
    data,
  };
}

export function getUserCourseRelation(data) {
  return {
    type: ActionTypes.GET_USER_COURSE_RELATION,
    data,
  };
}

export function addCourseGroupRelation(group) {
  return {
    type: ActionTypes.COURSE_ADD_GROUP_RELATION,
    group,
  };
}

export function removeCourseGroupRelation(index) {
  return {
    type: ActionTypes.COURSE_DEL_GROUP_RELATION,
    index,
  };
}

export function removeAllCourseGroupRelation(isAdminHasCourseRelation) {
  return {
    type: ActionTypes.COURSE_DEL_ALL_GROUP_RELATION,
    isAdminHasCourseRelation,
  };
}

export function editGroupPeriodTime(index, payload) {
  return {
    type: ActionTypes.COURSE_EDIT_GROUP_PERIOD_TIME,
    index,
    payload,
  };
}

export function doReceiveGroupCourseList(data) {
  return {
    type: ActionTypes.GET_GROUP_COURSE_RELATION,
    data,
  };
}

// Step 10.2.0 START
export function saveDetailSettingState(name, value) {
  return {
    type: ActionTypes.COURSE_SAVE_DETAIL_SETTING_STATE,
    name,
    value,
  };
}
// Step 10.2.0 END
